/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_LogoutInputs */

const vi_auth_logout = /** @type {(inputs: Auth_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng xuất`)
};

/**

* @param {Auth_LogoutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const auth_logout = /** @type {((inputs?: Auth_LogoutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_LogoutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_auth_logout(inputs)
});